module.exports = __webpack_public_path__ + "static/media/ic_friend.7915296a.png";